import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Orderinfo } from 'src/app/models/orderinfo';
import { AppConfigService } from 'src/app/services/app-config.service';
import { CustomerService } from 'src/app/services/customer.service';
import { InitializationService } from 'src/app/services/initialization.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { SummaryDialogComponent } from '../dialogs/summary-dialog/summary-dialog.component';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit 
{
  public fullName:string = '';
  public phone:string= '';
  public orderhistory:Array<any> = new Array();
  public isLoading:boolean = false;
  public placeName:string = '';

  constructor
  (
    private initializationservice:InitializationService, 
    private navigationservice:NavigationService,
    private route: ActivatedRoute,
    private customerservice : CustomerService,
    public alertDialog: MatDialog,
    private router: Router,
    private appconfigservice: AppConfigService,
    private localeservice: LocaleService
  ) { }

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

      return;
    }

    var customerData = this.customerservice.getCustomerData();

    this.fullName = customerData.Name;
    this.phone = customerData.Phone;
    this.placeName = this.appconfigservice.getPlaceName();

    this.getHistory();
  }

  async getHistory()
  {
    this.isLoading = true;

    this.orderhistory = await this.customerservice.getOrderHistory();

    this.isLoading = false;
  }


  back()
  {
    this.navigationservice.back();
  }
  
  editProfile()
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    this.router.navigateByUrl('/' + appname + '/editprofile?afterto=return&edit=true');
  }

  orderTapped(orderInfo:Orderinfo)
  {
    if(orderInfo.Summary.length > 0)
    {
      this.alertDialog.open(SummaryDialogComponent, 
      {
        height: 'fit-content',
        width: '90vw',
        data: 
        { 
          title:orderInfo.Name, 
          detail:orderInfo.Summary, 
          accept:this.localeservice.instantTranslation("Dialogs.Summary.OrderSummary.Accept") 
        }
      });
    }
  }
}
